class ProjectsController {

  // constructor, set_panel
  // show via state change

  constructor() {
    this.$panel = null;

    // Event handeling
    window.addEventListener('markers_changed', this.on_markers_change.bind(this));
    window.addEventListener('marker_clicked', this.on_marker_click.bind(this));
    window.addEventListener('close_infowindow', this.on_infowindow_close.bind(this));
    window.addEventListener('filters_changed', this.on_filters_change.bind(this) );
  }

  set_panel(elem) {
    const self = this;
    this.$panel = elem;
    this.$panel.find('.project-list-item').on('click', 
      self.item_clicked.bind(this)
    );
  }

  on_state_change(oldstate, newstate) {
    if( (newstate == window.werk.ARCHIVE) && (oldstate == window.werk.FEATURED) ) {
      this.show_years();
      this.$panel.addClass('show');
    } else {
      this.$panel.removeClass('show');
    }
  }

  on_marker_click(event) {
    let $listitem = jQuery('[data-post='+event.detail.post+']');
    let $container = jQuery('#ProjectListPanel');

    if($listitem.length) {

      let containerOffset = $container.offset().top;
      let itemOffset = $listitem.offset().top;
      let scrollOffset = 120;
      let scrollPosition = $container.scrollTop() + (itemOffset - containerOffset) - scrollOffset;

      $container.animate({ scrollTop: scrollPosition }, 500);

      this.select_listitem( $listitem );
    }
  }

  on_markers_change(event) {
    this.$panel
      .find('.project-list-item')
      .each( function() {
        let $this = jQuery(this);
        let id = parseInt($this.attr('data-post'));
        if( event.detail.posts.includes(id) ) {
          $this.addClass('show-map');
        } else {
          $this.removeClass('show-map');
        }
      });
    this.show_years();
  }

  show_years() {
    let year = '0';
    this.$panel
      .find('.project-list-item')
      .each( function() {
        let $year = jQuery(this).find('.project-year > span')
        if( $year.html() == year ) {
          $year.hide();
        } else {
          $year.show();
          year = $year.html();
        }
      })
  }

  item_clicked( e ) {
    let $this = jQuery(e.currentTarget);
    let id = $this.attr('data-post');
    this.select_listitem($this);
    let event = new CustomEvent('listitem_clicked', {
      detail : { post : id }
    });
    window.dispatchEvent(event);
  }

  on_infowindow_close() {
    jQuery('#ProjectListPanel .is-selected').removeClass('is-selected');
  }

  select_listitem( $listitem ) {
    jQuery('#ProjectListPanel .is-selected').removeClass('is-selected');
    $listitem.addClass('is-selected');
  }

  on_filters_change(event) {
    let $project_items = this.$panel.find('.project-list-item');
    $project_items.addClass('show-filter');

    if( event.detail.filters ) {
      if( event.detail.filters['project-sector'].length > 0) {
        $project_items.each( function(index, item) {
          let $item = jQuery(item);
          let sectorArr = JSON.parse($item.attr('data-project-sector'));
          let exists = sectorArr.some(element => jQuery.inArray(element.toString(), event.detail.filters['project-sector']) !== -1);
          if( !exists ) $item.removeClass('show-filter');
        });
      }
      if( event.detail.filters['project-expertise'].length > 0) {
        $project_items.each( function(index, item) {
          let $item = jQuery(item);
          let expertiseArr = JSON.parse($item.attr('data-project-expertise'));
          let exists = expertiseArr.some(element => jQuery.inArray(element.toString(), event.detail.filters['project-expertise']) !== -1);
          if( !exists ) $item.removeClass('show-filter');
        });
      }
    }

  }

  err_log( msg ) {
    console.log(msg);
    return false;
  }

}